import { aboutStats, milestones, teamValues } from "@/mocks/about";

export default function BrandStory() {
  return (
    <section className="px-6 md:px-10 py-14 md:py-18 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-16">
          {aboutStats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70"
            >
              <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-lg">
                <i className={`${stat.icon} text-lg text-primary-600`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="text-xs text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Brand Story */}
        <div className="max-w-[800px] mx-auto mb-16">
          <div className="text-center mb-10">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-book-3-line mr-1.5"></i>
              我们的故事
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              从三个娱记的梦想到
              <span className="text-primary-500">580万</span>
              用户的信赖
            </h2>
            <p className="text-sm text-foreground-500 max-w-[600px] mx-auto leading-relaxed">
              2018年，三位资深娱记厌倦了行业内真假难辨的乱象，决定创建一个真正对读者负责的娱乐八卦平台。
              八年过去，我们从一间小小的办公室起步，成长为华语娱乐圈最具影响力的八卦资讯门户。
            </p>
          </div>

          {/* Timeline */}
          <div className="relative">
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 -translate-x-1/2 hidden md:block"></div>

            <div className="space-y-8 md:space-y-0">
              {milestones.map((milestone, idx) => {
                const isLeft = idx % 2 === 0;
                return (
                  <div
                    key={milestone.year}
                    className={`relative flex flex-col md:flex-row items-start gap-4 md:gap-0 ${
                      isLeft ? "md:flex-row" : "md:flex-row-reverse"
                    } md:mb-10`}
                  >
                    {/* Timeline dot */}
                    <div className="absolute left-4 md:left-1/2 top-1.5 w-3 h-3 bg-primary-500 rounded-full -translate-x-1/2 ring-4 ring-background-50 z-10 hidden md:block"></div>

                    {/* Content card */}
                    <div
                      className={`ml-10 md:ml-0 md:w-[calc(50%-28px)] ${
                        isLeft ? "md:pr-8 md:text-right" : "md:pl-8"
                      }`}
                    >
                      <span className="inline-block text-xs font-bold text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full mb-2">
                        {milestone.year}
                      </span>
                      <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1.5">
                        {milestone.title}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        {milestone.description}
                      </p>
                    </div>

                    {/* Spacer for the other side */}
                    <div className="hidden md:block md:w-[calc(50%-28px)]"></div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Values Grid */}
        <div className="border-t border-background-200/70 pt-14">
          <div className="text-center mb-10">
            <span className="inline-flex items-center px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
              <i className="ri-star-line mr-1.5"></i>
              我们的坚持
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              用心做好每一个瓜
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {teamValues.map((value) => (
              <div
                key={value.title}
                className="p-5 bg-background-100 rounded-xl border border-background-200/70 text-center group hover:border-primary-300 transition-colors duration-300"
              >
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-primary-100 rounded-xl group-hover:bg-primary-200 transition-colors duration-300">
                  <i className={`${value.icon} text-xl text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">
                  {value.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}